import { BRAND_CONFIG } from '../../branding/brandConfig'

export const DEFAULT_BRAND_THEME = BRAND_CONFIG.theme
